import React, { useState } from 'react';
import { 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaPaperPlane, 
  FaUser, 
  FaPhone, 
  FaTag, 
  FaComment,
  FaGift,
  FaGraduationCap,
  FaCheckCircle
} from 'react-icons/fa';
import EmailForm from '../../modals/EmailForm';
import ContactLinks from './ContactLinks';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    privacy: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

   const handleEmail = () => {
    const email = "design@ctrl-plusx.com";
    const subject = "Hello";
    const body = "I want to contact you";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${subject}&body=${body}`;
    window.open(url, "_blank");
  };

  const contactWhatsAppConsultation = () => {
    const phoneNumber = "+213549075577";
    const message = "Bonjour! Je souhaite prendre un rendez-vous pour une consultation gratuite.";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const contactWhatsAppForm = () => {
    const phoneNumber = "+213549075577";
    const { name, email, phone, subject, message } = formData;
    const whatsappMessage = `
Nouvelle demande de contact:
👤 Nom: ${name}
📧 Email: ${email}
📞 Téléphone: ${phone}
🎯 Sujet: ${subject}
💬 Message: ${message}
    `.trim();
    
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    alert('Formulaire envoyé avec succès! Nous vous contacterons bientôt.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      privacy: false
    });
  };

  const openConsultationModal = () => {
    contactWhatsAppConsultation();
  };

  return (
    <section id="contact" className="pb-20 bg-gray-50 relative overflow-hidden">
      {/* Background decorative elements */} 
      <div className="max-w-7xl mx-auto px-4 relative z-10">

<div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-2">
                      <h1 className="text-4xl font-bold text-gray-800">Contactez-nous</h1>
                    </div>
    <p className="text-gray-500">
         Nous sommes là pour répondre à toutes vos questions </p>
        </div>
        {/* Enhanced Contact Form */}
        <EmailForm></EmailForm>
      </div>

      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </section>
  );
};

export default Contact;